import { render, staticRenderFns } from "./XcqOnlyImgOne.vue?vue&type=template&id=5c87f1f0&scoped=true&"
import script from "./XcqOnlyImgOne.vue?vue&type=script&lang=ts&"
export * from "./XcqOnlyImgOne.vue?vue&type=script&lang=ts&"
import style0 from "./XcqOnlyImgOne.vue?vue&type=style&index=0&id=5c87f1f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c87f1f0",
  null
  
)

export default component.exports